export default "__VITE_ASSET__Gp0UczQ2__"